import { withStyles } from "@material-ui/core/styles";
import styles from "./FranchiseFormStyles";
import { Button, Typography, Modal, Box, Grid, IconButton, Divider, TextField, Switch, FormControlLabel,Dialog, DialogTitle, DialogContentText, DialogActions, FormHelperText, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useState } from 'react'
import { httpRequest } from "../../../../../ui-utils/api";
import { backendHosts, apiUrl } from '../../../../../ui-utils/apiConfig'
import CloseIcon from '@mui/icons-material/Close';
import success from '../../../../../ui-assets/upload_success.gif'
import errorgif from '../../../../../ui-assets/upload_error.gif'
import loader from '../../../../../ui-assets/load.gif'
import validator from 'validator'
import axios from "axios";

const FranchiseForm = ({ classes, handleModal, setHandleModal, record, setRecord, franchiseList, setFranchiseList, handleReset, mainList ,setMainList }) => {

  const [open, setOpen] = useState(false);
  const [openLoader, setOpenLoader] = useState(false)
  const [load, setLoad] = useState("")
  const [dialogTittle, setDialogTittle] = useState("")
  const [dialogContent, setDialogContent] = useState("")
  const [error, setError] = useState({})
  let newError= {}

  console.log("record",record)

  const handleClose = () => {
    setHandleModal("")
    setOpen(false)
    setError({})
    newError={}
  };

  const handleClose1 = () => {
    setOpenLoader(false)
    setHandleModal("")
    setOpen(false)
    setDialogTittle("")
    setDialogContent("")
    setError({})
    newError={}
  }

  const handleChange = (e) => { //dev-trupti on 31-12-2024
    setRecord((prevRecord) => ({ ...prevRecord, franchiseetype: e.target.value,}))
  }

  const validate = () => {
    console.log("validate",record)
    if(record?.franchisee_code === null || record?.franchisee_code?.trim() === "" ){
      newError.franchisee_code = "Please enter Franchise Code";
    }
    if (record.franchiseetype === null || record.franchiseetype.trim() === ""){
      newError.franchiseetype = "Please enter Franchise Type";
    }
    if (record.feeamount === null || record.feeamount.trim() === ""){
      newError.feeamount = "Please enter Subscription Fee";
    }
    if (record.name === null || record.name.trim() === ""){
      newError.name = "Please enter Name";
    }
    if (record.email === null || record.email.trim() === ""){
      newError.email = "Please enter Email";
    }else if(!validator.isEmail(record.email)){
      newError.email = "Please enter valid Email";
    }
    if(record?.mobile === ""){
      newError.phone = "Please enter Phone number";
    }
    else if (record?.mobile.length !== 10){
      newError.phone = "Please enter valid Phone number";
    }
    if (record.district === null || record.district.trim() === ""){
      newError.district = "Please enter District";
    }
    if (record.state === null || record.state.trim() === ""){
      newError.state = "Please enter State";
    }
    if (record.pincode === null || record.pincode.trim() === ""){
      newError.pincode = "Please enter Pincode";
    }
    if (record.expert_advice_fee === null || record.expert_advice_fee.trim() === ""){
      newError.expert_advice_fee = "Please enter Expert Advice Fee";
    }
    if (record.expert_advice_days === null || record.expert_advice_days.trim() === ""){
      newError.expert_advice_days = "Please enter Expert Advice Days";
    }
    if (record.wealth_vault_fee === null || record.wealth_vault_fee.trim() === ""){
      newError.wealth_vault_fee = "Please enter Wealth Vault Fee";
    }
    if (record.wealth_vault_days === null || record.wealth_vault_days.trim() === ""){
      newError.wealth_vault_days = "Please enter Wealth Vault Days";
    }
  }

  const handleAdd = async() => {
    validate()

    if( Object.keys(newError).length === 0 ){
    setLoad("load")
    setOpenLoader(true)
    setDialogTittle("Adding New Record")
    setDialogContent("Please wait your record is getting inserted")
    try{
        if(record.wealth_vault_days == "0"){
          setRecord((prevRecord) => ({ ...prevRecord, wealth_vault_days:-1}))
        }
        const payload = {
          franchisee_code:record.franchisee_code,
          franchiseetype:record.franchiseetype,
          feeamount:record.feeamount,
          name:record.name,
          email:record.email,
          phone:record.phone,
          district:record.district,
          state:record.state,
          pincode:record.pincode,
          expert_advice_fee:record.expert_advice_fee,
          expert_advice_days:record.expert_advice_days == "0"? "-1" : record.expert_advice_days,
          wealth_vault_fee:record.wealth_vault_fee,
          wealth_vault_days:record.wealth_vault_days == "0"? "-1" : record.wealth_vault_days,
          status: record.status,
          app_download_status:record.app_download_status
        }
        const updatedResponse = await httpRequest({
          endPoint:`${backendHosts.ADMIN}${apiUrl.franchiseList}`,
          method: "post",
          instance: "instanceOne",
          requestBody:payload
      })
      if(updatedResponse.status === 200){
        setLoad("success")
        setDialogTittle("Successful")
        setDialogContent("Record is inserted successfully")
        handleReset()
      }
    }catch(err){
      setLoad("error")
      setDialogTittle("Error")
      setDialogContent("Something went wrong please try again")
      console.log("An Error", err)
    }
  }else{
    setError(newError);
  }
}

const handleEdit = async() => {
  validate()

  if( Object.keys(newError).length === 0 ){
  setLoad("load")
  setOpenLoader(true)
  setDialogTittle("Updating the Record")
  setDialogContent("Please wait your record is getting updated")
  try{
    let updatedResponse = {}
    console.log("payload",record)
    // updatedResponse = await axios.put(`http://localhost:4000/api/plan-franchise/plans`,record)
    // if(updatedResponse.status === 200){
    //   setLoad("success")
    //   setDialogTittle("Successful")
    //   setDialogContent("Record is updated successfully")
    //   const updatedList = franchiseList.map((ele)=>{
    //     if(ele.id === record.id){
    //       return record
    //     }else{
    //       return ele
    //     }
    //   })
    //   setFranchiseList(updatedList)

    //   //Updating main list
    //   const updateMainList = mainList.map((ele)=>{
    //     if(ele.id === record.id){
    //       return record
    //     }else{
    //       return ele
    //     }
    //   })
    //   setMainList(updateMainList)
      
    // }
  }catch(err){
    setLoad("error")
    setDialogTittle("Error")
    setDialogContent("Something went wrong please try again")
    console.log("An Error", err)
  }
}else{
  setError(newError);
}
}

  return (
    <>
      <Modal
        open={handleModal === "" ? false:true}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.boxStyle} sx={{width : handleModal === "View" ? '35%' : '50%'}}>
          {handleModal === "View" && <>
          <Grid className={classes.header}>
            <Grid> <Typography className={classes.heading}> Details </Typography></Grid>
            <Grid><IconButton onClick={handleClose}>
                    <CloseIcon fontSize="20px"/>
                  </IconButton>
            </Grid>
          </Grid>
          <Divider/>
          <Grid container className={classes.mainGrid}>
            <Grid>
              <Typography className={classes.detailsHeading}>Franchise Code</Typography>
              <Typography className={classes.detailsHeading}>Franchisee Type</Typography>
              <Typography className={classes.detailsHeading}>Email</Typography>
              <Typography className={classes.detailsHeading}>Phone</Typography>
              <Typography className={classes.detailsHeading}>State</Typography>
              <Typography className={classes.detailsHeading}>District</Typography>
              <Typography className={classes.detailsHeading}>Pincode</Typography>
            </Grid>
            <Grid className={classes.subGrid}>
              <Typography className={classes.deatilsInfo} sx={{fontWeight:900}}>{record.franchisee_code}</Typography>
              <Typography className={classes.deatilsInfo}>{record.franchiseetype}</Typography>
              <Typography className={classes.deatilsInfo}>{record.email}</Typography>
              <Typography className={classes.deatilsInfo}>{record.mobile || "NA"}</Typography>
              <Typography className={classes.deatilsInfo}>{record.state}</Typography>
              <Typography className={classes.deatilsInfo}>{record.district}</Typography>
              <Typography className={classes.deatilsInfo}>{record.pincode}</Typography>
            </Grid>              
          </Grid>
          </>}

          {(handleModal === "Edit" || handleModal === "Add") && <>
            <Grid className={classes.header}>
            <Grid> <Typography className={classes.headingEdit}> {handleModal} </Typography></Grid>
            <Grid><IconButton onClick={handleClose}>
                    <CloseIcon fontSize="20px"/>
                  </IconButton>
            </Grid>
          </Grid>
          <Grid container className={classes.mainGridEdit}>
            <Grid className={classes.textFeildGrid}>

              <Grid className={classes.textfeild}>
                <TextField error={Boolean(error.franchisee_code)} className={classes.textFeild3} value={record.franchisee_code} onChange={(e) => {setRecord((prevRecord) => ({ ...prevRecord, franchisee_code: e.target.value,}))}} label="Franchisee Code" variant="outlined" />
                <FormHelperText error={Boolean(error.franchisee_code)}>{error.franchisee_code}</FormHelperText> 
              </Grid>

              <Grid className={classes.textfeild}>
                {/* <TextField error={Boolean(error.franchiseetype)} className={classes.textFeild3} value={record.franchiseetype} onChange={(e) => {setRecord((prevRecord) => ({ ...prevRecord, franchiseetype: e.target.value,}))}} label="Franchisee Type" variant="outlined" /> */}
                <FormControl  error={Boolean(error.franchiseetype)}> 
                  <InputLabel id="demo-simple-select-label">Franchisee Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={record.franchiseetype}
                    label="Franchisee Type"
                    onChange={handleChange}
                  >
                    <MenuItem value={"Digi_Franchise"}>Digital Franchise</MenuItem>
                    <MenuItem value={"Campaign"}>Campaign</MenuItem>
                    <MenuItem value={"Full_Franchaise"}>Full Franchaise</MenuItem>
                  </Select>
                </FormControl>
                <FormHelperText error={Boolean(error.franchiseetype)}>{error.franchiseetype}</FormHelperText> 
              </Grid>

              <Grid className={classes.textfeild}>
                <TextField error={Boolean(error.feeamount)} className={classes.textFeild3} value={record.feeamount} 
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) { 
                    setRecord((prevRecord) => ({ ...prevRecord, feeamount: value }));
                  }
                }}
                label="Subscription Fee" variant="outlined" />
                <FormHelperText error={Boolean(error.feeamount)}>{error.feeamount}</FormHelperText> 
              </Grid>

            </Grid>

            <Grid className={classes.textFeildGrid}>

            <Grid className={classes.textfeild}>
            <TextField error={Boolean(error.name)} className={classes.textFeild3} value={record.name} onChange={(e) => {setRecord((prevRecord) => ({ ...prevRecord, name: e.target.value,}))}} label="Name" variant="outlined" />
            <FormHelperText error={Boolean(error.name)}>{error.name}</FormHelperText> 
            </Grid>

            <Grid className={classes.textfeild}>
            <TextField error={Boolean(error.email)} className={classes.textFeild3} value={record.email} onChange={(e) => {setRecord((prevRecord) => ({ ...prevRecord, email: e.target.value,}))}} label="Email" variant="outlined" />
            <FormHelperText error={Boolean(error.email)}>{error.email}</FormHelperText> 
            </Grid>

            <Grid className={classes.textfeild}>
            <TextField error={Boolean(error.phone)} className={classes.textFeild3} value={record.phone}  type='tel'
            onChange={(e) => {
              let value = e.target.value.replace(/[^0-9]/g, '');
                            if (value.length > 10) {
                                value = value.slice(0, 10);
                            }
                            e.target.value = value;
                            setRecord((prevRecord) => ({ ...prevRecord, phone: value }));

            }}
             label="Phone number" variant="outlined" />
            <FormHelperText error={Boolean(error.phone)}>{error.phone}</FormHelperText> 
            </Grid>

            </Grid> 

            <Grid className={classes.textFeildGrid}>
            
            <Grid className={classes.textfeild}>
            <TextField error={Boolean(error.district)} className={classes.textFeild3} value={record.district} onChange={(e) => {setRecord((prevRecord) => ({ ...prevRecord, district: e.target.value,}))}} label="District" variant="outlined" />
            <FormHelperText error={Boolean(error.district)}>{error.district}</FormHelperText> 
            </Grid>

            <Grid className={classes.textfeild}>
            <TextField error={Boolean(error.state)} className={classes.textFeild3} value={record.state} onChange={(e) => {setRecord((prevRecord) => ({ ...prevRecord, state: e.target.value,}))}} label="State" variant="outlined" />
            <FormHelperText error={Boolean(error.state)}>{error.state}</FormHelperText> 
            </Grid>

            <Grid className={classes.textfeild}>
            <TextField error={Boolean(error.pincode)} className={classes.textFeild3} value={record.pincode} 
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) { 
                setRecord((prevRecord) => ({ ...prevRecord, pincode: value }));
              }
            }}
            label="Pincode" variant="outlined" />
            <FormHelperText error={Boolean(error.pincode)}>{error.pincode}</FormHelperText> 
            </Grid>

            </Grid> 

            <Grid className={classes.textFeildGrid}>

            <Grid className={classes.textfeild}>
            <TextField error={Boolean(error.expert_advice_fee)} className={classes.textFeild3} value={record.expert_advice_fee} 
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) { 
                setRecord((prevRecord) => ({ ...prevRecord, expert_advice_fee: value }));
              }
            }}
            label="Expert Advice Fee" variant="outlined" />
            <FormHelperText error={Boolean(error.expert_advice_fee)}>{error.expert_advice_fee}</FormHelperText> 
            </Grid>

            <Grid className={classes.textfeild}>
            <TextField error={Boolean(error.expert_advice_days)} className={classes.textFeild3} value={record.expert_advice_days} onChange={(e) => {setRecord((prevRecord) => ({ ...prevRecord, expert_advice_days: e.target.value,}))}} label="Expert Advice Days" variant="outlined" />
            <FormHelperText error={Boolean(error.expert_advice_days)}>{error.expert_advice_days}</FormHelperText> 
            </Grid>

            <Grid className={classes.textfeild} sx={{paddingLeft:'10px !important', display:'flex !important', justifyContent:'center !important'}}>
            <Box className={classes.textFeild3}>
            <FormControlLabel  label="Status" control={<Switch
              checked={record.status}
              onChange={() => {
                setRecord((prevRecord) => ({
                  ...prevRecord,
                  status: !prevRecord.status,
                }));
              }}
              size="small"
              inputProps={{ 'aria-label': 'controlled' }}
            />}></FormControlLabel >
            </Box>
            </Grid>

            </Grid>

            <Grid className={classes.textFeildGrid}>

            <Grid className={classes.textfeild}>
            <TextField error={Boolean(error.wealth_vault_fee)} className={classes.textFeild3} value={record.wealth_vault_fee} 
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) { 
                setRecord((prevRecord) => ({ ...prevRecord, wealth_vault_fee: value }));
              }
            }} 
            label="Wealth Vault Fee" variant="outlined" />
            <FormHelperText error={Boolean(error.wealth_vault_fee)} >{error.wealth_vault_fee}</FormHelperText> 
            </Grid>

            <Grid className={classes.textfeild}>
            <TextField error={Boolean(error.wealth_vault_days)} className={classes.textFeild3} value={record.wealth_vault_days} onChange={(e) => {setRecord((prevRecord) => ({ ...prevRecord, wealth_vault_days: e.target.value,}))}} label="Wealth Vault Days" variant="outlined" />
            <FormHelperText error={Boolean(error.wealth_vault_days)}>{error.wealth_vault_days}</FormHelperText> 
            </Grid>

            <Grid className={classes.textfeild} sx={{paddingLeft:'10px !important', display:'flex !important', justifyContent:'center !important'}}>
            <Box className={classes.textFeild3} >
            <FormControlLabel  label="App Download Status" control={<Switch
              checked={record.app_download_status}
              onChange={() => {
                setRecord((prevRecord) => ({
                  ...prevRecord,
                  app_download_status: !prevRecord.app_download_status,
                }));
              }}              
              size="small"
              inputProps={{ 'aria-label': 'controlled' }}
            />}></FormControlLabel >
            </Box>
            </Grid>

            </Grid>
            <Grid className={classes.buttonGrid} >
              <Button  className={classes.button} onClick={()=>{
                if(handleModal === "Edit"){
                  handleEdit()
                }else{
                  // handleAdd() 
                }}}>Save</Button>
            </Grid> 
          </Grid>

          </>}
        </Box>
      </Modal>
      {/* Loading Dialog */}
      <Dialog
        open={openLoader}
        onClose={handleClose1}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            width: '400px',  
            height: '380px', 
          }
        }}
      >
        <Box className={classes.alertbox}><img src={load === "load" ? loader : (load === "success" ? success : errorgif )} height={200}></img></Box>
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle} >
          {dialogTittle}
        </DialogTitle>
          <DialogContentText id="alert-dialog-description" className={classes.dialogContentText}>
            {dialogContent}
          </DialogContentText>
        <DialogActions className={classes.dialogAction}>
          <Button 
          className={load !== "load" ? classes.button : classes.disabledButton}
           onClick={handleClose1} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default withStyles(styles)(FranchiseForm);
